import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';
import { Globe, ChevronDown } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'ar', label: 'العربية', flag: '🇹🇳' }
  ];

  const currentLang = languages.find(lang => lang.code === language);

  const handleLanguageChange = (code) => {
    setLanguage(code);
    setIsOpen(false);
    
    // Apply RTL for Arabic
    if (code === 'ar') {
      document.documentElement.setAttribute('dir', 'rtl');
      document.documentElement.setAttribute('lang', 'ar');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
      document.documentElement.setAttribute('lang', code);
    }
  };

  return (
    <div className="language-switcher-container">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="language-switcher"
        aria-label="Change language"
      >
        <Globe size={18} />
        <span>{currentLang?.flag} {currentLang?.code.toUpperCase()}</span>
        <ChevronDown size={16} className={`chevron ${isOpen ? 'open' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {languages.map(lang => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`language-option ${language === lang.code ? 'active' : ''}`}
            >
              <span className="flag">{lang.flag}</span>
              <span className="label">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
